module.exports = __webpack_public_path__ + "img/card_technicalasistance_teachingsupport.4ce1ae40.svg";